import type {
  AssignableAsset,
  EligibleSupervisor,
  SupervisorAssignmentCreateResult,
  SupervisorAssignmentDetail,
  SupervisorAssignmentHistoryItem,
  SupervisorAssignmentListItem,
} from "../domain";
import type {
  AssetWithBranchDto,
  CreatedAssignmentDto,
  EligibleSupervisorDto,
  SupervisorAssignmentDetailDto,
  SupervisorAssignmentHistoryItemDto,
  SupervisorAssignmentListItemDto,
} from "./supervisorAssignmentDtos";

export function eligibleSupervisorFromDto(
  dto: EligibleSupervisorDto,
): EligibleSupervisor {
  return {
    id: dto.id,
    nameEn: dto.nameEn,
    nameAr: dto.nameAr,
    username: dto.username,
  };
}

export function supervisorAssignmentCreateResultFromDto(
  rows: readonly CreatedAssignmentDto[],
): SupervisorAssignmentCreateResult {
  return {
    assignments: rows.map((row) => ({
      id: row.id,
      assetId: row.assetId,
      assignedAt: row.assignedAt,
    })),
  };
}

export function assignableAssetFromDto(dto: AssetWithBranchDto): AssignableAsset {
  return {
    id: dto.id,
    code: dto.code,
    nameEn: dto.nameEn,
    nameAr: dto.nameAr,
    branch: {
      id: dto.branch.id,
      nameEn: dto.branch.nameEn,
      nameAr: dto.branch.nameAr,
    },
  };
}

export function supervisorAssignmentListItemFromDto(
  dto: SupervisorAssignmentListItemDto,
): SupervisorAssignmentListItem {
  return {
    id: dto.supervisorId,
    supervisor: {
      id: dto.supervisorId,
      nameEn: dto.supervisorNameEn,
      nameAr: dto.supervisorNameAr,
    },
    assignedAssetsCount: dto.assetCount,
    updatedAt: dto.lastUpdatedAt,
  };
}

export function supervisorAssignmentHistoryItemFromDto(
  dto: SupervisorAssignmentHistoryItemDto,
): SupervisorAssignmentHistoryItem {
  return {
    id: dto.id,
    supervisorNameEn: dto.supervisorNameEn,
    supervisorNameAr: dto.supervisorNameAr,
    assetNameEn: dto.assetNameEn,
    assetNameAr: dto.assetNameAr,
    assignedByName: dto.assignedByName,
    action: dto.action,
    assignedAt: dto.assignedAt,
    actionAt: dto.actionAt,
  };
}

export function supervisorAssignmentDetailFromDto(
  dto: SupervisorAssignmentDetailDto,
): SupervisorAssignmentDetail {
  return {
    supervisor: eligibleSupervisorFromDto(dto.supervisor),
    assets: dto.assignments.map((assignment) => ({
      id: assignment.asset.id,
      nameEn: assignment.asset.nameEn,
      nameAr: assignment.asset.nameAr,
    })),
  };
}
